'use strict'

/**
 * Module de fonction tools
 */

/*
 * Fonction qui vérifie si un élément dans la page est affiché dans l'écran du browser
 */
function isElementInViewport(el) {
    // special bonus for those using jQuery
    if (el instanceof $) {
        el = el[0]
    }

    const rect = el.getBoundingClientRect()

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            $(window).height() +
                $(window).height() * 0.5 /* or $(window).height() */ &&
        rect.right <=
            $(window).width() +
                $(window).width() * 0.5 /* or $(window).width() */
    )
}

export default {
    isElementInViewport: isElementInViewport
}
